module.exports = __webpack_public_path__ + "static/media/Warehouse-with-lights.9bece622.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backgrounds/Warehouse-with-lights.jpg
// module id = 562
// module chunks = 0